<script>
import CustomDialog from "@/components/_Shared/Dialog";

import { mapState, mapActions } from "vuex";
import dateMixin from "@/mixins/dateMixin";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [dateMixin],

  components: {
    CustomDialog
  },

  computed: {
    ...mapState("newOrder", ["day"])
  },

  methods: {
    ...mapActions("newOrder", [
      "acceptWontHaveInstantSupport",
      "rejectWontHaveInstantSupport"
    ]),

    accept() {
      this.acceptWontHaveInstantSupport();
      this.$emit("accept");
    },

    reject() {
      this.rejectWontHaveInstantSupport();
      this.$emit("reject");
    }
  }
};
</script>

<template>
  <custom-dialog :visible="visible" icon="/static/icon-alert-purple.svg" title="Confirme para finalizar seu pedido">
    <template slot="body">
      <p>
        Você escolheu o dia
        <b>{{day | formatDate("DD/MM/Y")}}</b>, neste dia não haverá suporte do time de atendimento!
        Em casos de <b>Imprevistos</b>,
        <b>reagendamentos</b> ou
        <b>cancelamentos</b> nesse dia, deverá ser aberto um ticket de atendimento que será tratado
        <b>antes</b> ou no
        <b>próximo dia útil</b>. Você está ciente e deseja prosseguir?
      </p>
      <hr />
      <p>Nosso atendimento é de segunda à sexta das 7h30 às 21h, sábado das 8h às 16h e domingo das 10h às 13h e 16h às 19h.</p>

      <div class="btn-group">
        <div class="btn bg-purple-outline" @click="reject()">Não, desejo escolher outra data</div>
        <div class="btn bg-purple" @click="accept()">Sim, estou ciente</div>
      </div>
    </template>
  </custom-dialog>
</template>

<style scoped>
hr {
  width: 50px;
  background-color: transparent;
  border: 1px solid var(--purple);
  border-bottom: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/WontHaveInstantSupport.vue